export default __webpack_public_path__ + "static/media/HDTX_Audit Report 2024.e255f532.pdf";